import React, { FC, PropsWithChildren } from 'react';

import { ErrorBoundary as ErrorBoundaryBase, type ErrorBoundaryProps as ErrorBoundaryPropsBase } from 'app/design-system/components/ErrorBoundary';
import { useTranslation } from 'app/lang';

import dictionary from './ErrorBoundary.dictionary.json';

// ---

type ErrorBoundaryProps = {
  fallbackText?: ErrorBoundaryPropsBase['fallbackText'];
};

const ErrorBoundary: FC<PropsWithChildren<ErrorBoundaryProps>> = ({ fallbackText, children }) => {
  const { t } = useTranslation();

  const errorText = fallbackText || t(dictionary.errorText);

  return (
    <ErrorBoundaryBase fallbackText={errorText}>
      {children}
    </ErrorBoundaryBase>
  );
};

export default ErrorBoundary;
